/*** IMPORTS FROM imports-loader ***/
var define = false;

import Masonry from 'masonry-layout';

// Masonry for profile cards
const profileCardsMasonry = [];

function layout() {
  profileCardsMasonry.forEach((masonry) => {
    // Needs reloadItems in order to recalculate the height of items given extra padding to vertically stagger.
    masonry.reloadItems();

    // IE and Firefox prefer a small timeout before recalculating
    setTimeout(() => {
      masonry.layout();
    }, 1);
  });
}

function add(list) {
  profileCardsMasonry.push(
    new Masonry(list, {
      itemSelector: '.profile-card:not([hidden])',
      columnWidth: '.profile-card:not([hidden])',
      percentPosition: true,
      stagger: 10,
      transitionDuration: 200,
      horizontalOrder: false,
    }),
  );

  // Reload masonry after lazyload
  const images = list.querySelectorAll('img');
  images.forEach((image) => {
    image.addEventListener('lazyloaded', () => {
      layout();
    });
  });
}

function destroy() {
  profileCardsMasonry.forEach((masonry) => {
    masonry.destroy();
  });
  profileCardsMasonry.length = 0;
}

function init(selector) {
  const profileCardsList = document.querySelectorAll(selector);
  profileCardsList.forEach((list) => {
    add(list);
  });
}

export default {
  init: init,
  add: add,
  layout: layout,
  destroy: destroy,
};

